import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-317458d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-list" }
const _hoisted_2 = { class: "price" }
const _hoisted_3 = { class: "price-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "定金：", -1))
const _hoisted_5 = { class: "price" }

import { withDefaults } from 'vue'
import { ChildProductItem } from '@/types/device-replace-v3'
import RecordBlockWrapper from './record-block-wrap.vue'
import ActivityProduct from './activity-product-item.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'pay-product-block',
  props: {
    title: { default: '' },
    price: { default: 0 },
    productName: { default: '' },
    productImages: { default: () => [''] },
    productChild: { default: () => [] }
  },
  emits: ['updatePopupShow'],
  setup(__props: any, { emit: emits }) {

const props = __props as { title: string, price: number, productName: string, productImages: string[], productChild: Array<ChildProductItem> };



function onUpdatePopupShow(show: boolean) {
  emits('updatePopupShow', show)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RecordBlockWrapper, {
    class: "product-info",
    title: props.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(ActivityProduct, {
              name: __props.productName,
              images: __props.productImages,
              child: __props.productChild,
              onUpdatePopupShow: onUpdatePopupShow
            }, {
              "info-extra": _withCtx(() => [
                _createElementVNode("div", _hoisted_2, "定金：￥" + _toDisplayString(__props.price.toFixed(2)), 1)
              ]),
              _: 1
            }, 8, ["name", "images", "child"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, "￥" + _toDisplayString(__props.price.toFixed(2)), 1)
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})